const get = require("lodash.get");
const $ = require("jquery");
const userProfile = require("site/mobile/user-profile");
const modalWindow = require("site/mobile/modal-window");
const showLoginResetRequiredPopup = require("site/mobile/log-in-reset-required");
const showVerifyPasswordPopup = require("site/mobile/verify-password");
const changeCheckoutPage = require("site/mobile/checkout/page-changer");
const loginEvents = require("site/common/analytics/login-events");
const {
  mParticleLogin,
  mParticleCustomEventLogIn,
  mParticleCustomEventRegister
} = require("common/analytics/mParticle");

function handleRedirection ({ $form, redirectTo, pageVariant }) {
  if (redirectTo) {
    window.location.href = redirectTo;
    return;
  }
  if (pageVariant === "checkout") {
    const currentUri = window.window.location.hash.split("?");
    changeCheckoutPage("checkout-page", currentUri[1]);
    return;
  }
  const $formTarget = $form.find("[data-target-uri]");
  if ($formTarget.length) {
    const { targetUri } = $formTarget.data();
    window.location.href = targetUri;
    return;
  }
  window.location.href = "/";
}

module.exports = function login ({
  $loginForm,
  validator,
  userEmail,
  userPassword,
  googleIdToken,
  pageVariant,
  targetUri
}) {
  const trackingEvents = $loginForm.selector.includes("checkout-log-in")
    ? loginEvents.trackEventLogInCheckout()
    : loginEvents.trackEventLogInPage();

  modalWindow.show();

  const $email = $($loginForm).find(".login-email");
  const $loginEmailInput = $email.length ? $email : null;

  return userProfile
    .login(userEmail, userPassword, googleIdToken)
    .then((response) => {
      const { userTypePriorLogin } = response;
      let socialNetworkLogin;
      if (googleIdToken) {
        socialNetworkLogin = "google";
      }

      trackingEvents
        .success({
          network: socialNetworkLogin,
          userTypePriorLogin
        })
        .then(() => {
          const { accountId } = response;
          mParticleLogin(
            {
              userIdentities: { email: userEmail, customerid: `${accountId}` }
            },
            () => {
              if (socialNetworkLogin && userTypePriorLogin === "NEW") {
                mParticleCustomEventRegister(socialNetworkLogin);
              }
              if (socialNetworkLogin) {
                mParticleCustomEventLogIn(socialNetworkLogin);
              } else {
                mParticleCustomEventLogIn("password");
              }
              handleRedirection({
                $form: $loginForm,
                redirectTo: targetUri,
                pageVariant
              });
            }
          );
        });
      return response;
    }).catch((reason) => {
      const loginStatus = get(reason, ["responseJSON", "errors", 0, "name"]);
      let socialNetworkLogin;
      if (googleIdToken) {
        socialNetworkLogin = "google";
      }
      switch (loginStatus) {
      case "not_authenticated":
        trackingEvents.failure();
        validator.errorPopup("error-message", $loginEmailInput);
        break;
      case "locked":
        trackingEvents.failure();
        showLoginResetRequiredPopup(true);
        break;
      case "requires_reset":
        trackingEvents.failure();
        showLoginResetRequiredPopup(false);
        break;
      case "google_needs_password_authentication":
        trackingEvents.failure({ network: "google", loginStatus });
        showVerifyPasswordPopup({ googleIdToken, pageVariant });
        break;
      default:
        trackingEvents.failure({ network: socialNetworkLogin, loginStatus });
        validator.errorPopup("generic-error-message");
      }
      modalWindow.hide();
    });
};
